import React from 'react';
import {
  ChevronLeft, ChevronRight, X, Check,
  Settings, GripVertical, Pencil, Trash2,
  EyeOff, Camera, Sparkles, Image, RotateCcw,
  Crosshair, Search, Upload, Crop,
  Plane, BedDouble, Utensils, Landmark,
  Lightbulb, FileText, Lock, Zap,
  Save, ClipboardList, AlertTriangle,
  Train, Bus, Ship, Car,
  TreePine, ShoppingBag, Music, Coffee, Waves, Sun, Heart, Ticket,
  MoreHorizontal, Download, FileDown
} from 'lucide-react';

export const ICON_MAP = {
  // Navigation
  back:           ChevronLeft,
  forward:        ChevronRight,
  close:          X,
  confirm:        Check,
  settings:       Settings,
  drag:           GripVertical,

  // Actions
  edit:           Pencil,
  delete:         Trash2,
  hide:           EyeOff,
  snapshot:       Camera,
  rewrite:        Sparkles,
  changeImage:    Image,
  unbook:         RotateCcw,
  save:           Save,
  clipboard:      ClipboardList,
  warning:        AlertTriangle,

  // AI markers
  aiSparkle:      Zap,

  // ImageEditor tabs
  imagePick:      Crosshair,
  imageSearch:    Search,
  imageUpload:    Upload,
  imageCrop:      Crop,

  // Transit modes
  train:          Train,
  bus:            Bus,
  ferry:          Ship,
  drive:          Car,

  // Activity categories
  transport:      Plane,
  accommodation:  BedDouble,
  dining:         Utensils,
  culture:        Landmark,
  nature:         TreePine,
  shopping:       ShoppingBag,
  nightlife:      Music,
  cafe:           Coffee,
  beach:          Waves,
  leisure:        Sun,
  wellness:       Heart,
  activity:       Ticket,
  tip:            Lightbulb,
  notes:          FileText,
  lock:           Lock,

  // Menu & export
  overflow:       MoreHorizontal,
  download:       Download,
  fileDown:       FileDown,
};

export function Icon({ name, size = 16, color, strokeWidth = 1.5, style }) {
  const C = ICON_MAP[name];
  if (!C) return null;
  return <C size={size} color={color} strokeWidth={strokeWidth} style={style} />;
}
